import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../api";
import { Boxes, Plus, Minus, Trash2, AlertTriangle } from "lucide-react";

const EMPTY = { name:"", quantity:0, unit:"un", min_stock:0, notes:"" };

export default function MaterialsTab() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);

  const load = () => { api.get("/admin/materials").then(r=>setItems(r.data)); };
  useEffect(load, []);

  const create = async () => {
    if (!form.name) { toast.error("Nome obrigatório"); return; }
    await api.post("/admin/materials", {
      ...form, quantity: Number(form.quantity)||0, min_stock: Number(form.min_stock)||0
    });
    toast.success("Material adicionado");
    setForm(EMPTY); load();
  };
  const adjust = async (id, delta) => {
    const raw = window.prompt(`Quantidade para ${delta>0 ? 'ADICIONAR' : 'RETIRAR'}:`, "1");
    if (raw === null) return;
    const n = Number(raw);
    if (!n || n <= 0) return toast.error("Valor inválido");
    await api.post(`/admin/materials/${id}/adjust`, { delta: delta>0 ? n : -n, reason: "" });
    toast.success("Estoque atualizado"); load();
  };
  const del = async (id) => {
    if (!window.confirm("Excluir material?")) return;
    await api.delete(`/admin/materials/${id}`); toast.success("Excluído"); load();
  };

  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 card-arya overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[var(--cream-100)] text-left text-xs tracking-widest font-display">
            <tr><th className="p-4">MATERIAL</th><th className="p-4">QUANTIDADE</th><th className="p-4">ESTOQUE MÍN.</th><th className="p-4">STATUS</th><th className="p-4">AJUSTAR</th><th className="p-4"></th></tr>
          </thead>
          <tbody className="divide-y divide-[var(--line)]">
            {items.map(m => {
              const low = m.quantity <= m.min_stock;
              return (
                <tr key={m.material_id} data-testid={`mat-${m.material_id}`}>
                  <td className="p-4">
                    <div className="font-display font-semibold">{m.name}</div>
                    {m.notes && <div className="text-xs text-[color:var(--ink-500)]">{m.notes}</div>}
                  </td>
                  <td className="p-4"><span className="font-serif text-xl text-[color:var(--sun-700)]">{m.quantity}</span> <span className="text-xs text-[color:var(--ink-500)]">{m.unit}</span></td>
                  <td className="p-4">{m.min_stock} {m.unit}</td>
                  <td className="p-4">
                    {low ? <span className="tag-sun !text-[color:var(--danger)] !border-[color:var(--danger)]/40 !bg-[rgba(179,58,58,.08)] inline-flex items-center gap-1"><AlertTriangle size={12}/> Repor</span> : <span className="tag-sun">OK</span>}
                  </td>
                  <td className="p-4 flex gap-2">
                    <button onClick={()=>adjust(m.material_id, +1)} className="p-1.5 rounded-full border border-[color:var(--success)] text-[color:var(--success)]" data-testid={`add-mat-${m.material_id}`}><Plus size={14}/></button>
                    <button onClick={()=>adjust(m.material_id, -1)} className="p-1.5 rounded-full border border-[color:var(--danger)] text-[color:var(--danger)]" data-testid={`sub-mat-${m.material_id}`}><Minus size={14}/></button>
                  </td>
                  <td className="p-4"><button onClick={()=>del(m.material_id)} className="p-1 text-[color:var(--danger)]"><Trash2 size={16}/></button></td>
                </tr>
              );
            })}
            {items.length===0 && <tr><td colSpan="6" className="p-8 text-center text-[color:var(--ink-500)]">Nenhum material cadastrado.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="card-arya p-6 h-fit">
        <h3 className="font-serif text-xl mb-3 flex items-center gap-2"><Boxes size={16}/> Novo material</h3>
        <div className="space-y-2">
          <input placeholder="Nome (ex: Acetona, Esmalte OPI Vermelho)" value={form.name} onChange={e=>setForm({...form, name:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="mat-name"/>
          <div className="grid grid-cols-3 gap-2">
            <input type="number" step="0.01" placeholder="Qtd" value={form.quantity} onChange={e=>setForm({...form, quantity:e.target.value})}
                   className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="mat-qty"/>
            <select value={form.unit} onChange={e=>setForm({...form, unit:e.target.value})}
                    className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="mat-unit">
              <option value="un">un</option><option value="ml">ml</option><option value="g">g</option><option value="cx">cx</option>
            </select>
            <input type="number" step="0.01" placeholder="Min" value={form.min_stock} onChange={e=>setForm({...form, min_stock:e.target.value})}
                   className="rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm" data-testid="mat-min"/>
          </div>
          <input placeholder="Notas (opcional)" value={form.notes} onChange={e=>setForm({...form, notes:e.target.value})}
                 className="w-full rounded-xl border border-[var(--line)] bg-white px-3 py-2 text-sm"/>
          <button onClick={create} className="btn-gold w-full" data-testid="btn-save-mat">Adicionar material</button>
        </div>
      </div>
    </div>
  );
}
